import { addVariantToCart } from '@theme/cart-add';

class CollectionTabsProducts extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-collection-tab]')];
    this.panels = [...this.querySelectorAll('[data-collection-panel]')];
    this.activeIndex = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
    if (this.activeIndex < 0) this.activeIndex = 0;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.collectionTab);
        if (!Number.isNaN(index)) this.selectTab(index);
      });
    });

    this.addEventListener('click', this.#onAddToCart);
    this.selectTab(this.activeIndex);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onAddToCart);
  }

  selectTab(index) {
    this.activeIndex = index;

    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }

  #onAddToCart = async (event) => {
    const button = event.target.closest('.ctp-card__atc');
    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    const sectionId = button.dataset.sectionId;
    if (!variantId) return;

    const textSpan = button.querySelector('.ctp-card__atc-text');
    const loadingSpan = button.querySelector('.ctp-card__atc-loading');
    const successSpan = button.querySelector('.ctp-card__atc-success');

    button.disabled = true;
    textSpan?.setAttribute('hidden', 'hidden');
    loadingSpan?.removeAttribute('hidden');

    try {
      await addVariantToCart(variantId, {
        source: 'collection-tabs-products',
        sourceId: sectionId || '',
        refreshSectionId: sectionId || undefined,
      });

      loadingSpan?.setAttribute('hidden', 'hidden');
      successSpan?.removeAttribute('hidden');

      window.setTimeout(() => {
        successSpan?.setAttribute('hidden', 'hidden');
        textSpan?.removeAttribute('hidden');
        button.disabled = false;
      }, 1500);
    } catch (error) {
      console.error('Failed to add product to cart:', error);
      loadingSpan?.setAttribute('hidden', 'hidden');
      textSpan?.removeAttribute('hidden');
      button.disabled = false;
      window.alert(error.message || 'Failed to add to cart');
    }
  };
}

if (!customElements.get('collection-tabs-products')) {
  customElements.define('collection-tabs-products', CollectionTabsProducts);
}
